import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ReactJson from 'react-json-view';

const PoiExtra = ({ details }) => {
    const [isCollapsed, setIsCollapsed] = useState(true); // State for collapse/expand

    let parsedExtra = {};
    try {
        parsedExtra = details ? JSON.parse(details.data.extra) : {};
    } catch (error) {
        console.error("Error parsing extra:", error);
        parsedExtra = { error: "Invalid JSON format" };
    }

    return (
        <div className="booking-experience-images-container-wrapper">
            <button
                onClick={() => setIsCollapsed(!isCollapsed)}
                style={{
                    marginBottom: "10px",
                    padding: "5px 10px",
                    cursor: "pointer",
                    backgroundColor: "#007BFF",
                    color: "#fff",
                    border: "none",
                    borderRadius: "5px"
                }}>
                {isCollapsed ? "Expand JSON" : "Collapse JSON"}
            </button>

            <ReactJson
                src={parsedExtra}
                theme="monokai"
                collapsed={isCollapsed}
                displayDataTypes={false}
                enableClipboard={true}
            />
        </div>
    );
};

PoiExtra.propTypes = {
    details: PropTypes.string,
};

export default PoiExtra;
